import { IEventDefinition } from "@highway/mbs-analytics";

export const appEvents: Record<string, IEventDefinition> = {
    purchase_analysis_start: {
        description: "Fires when a user lands on the Purchase Analysis Step 1 page.",
        mappings: {
            mixpanel: "purchase_analysis_start",
        },
    },
    purchase_analysis_step1_submit: {
        description: 'Fires when a user submits Step 1 by clicking the "Next" button.',
        mappings: {
            mixpanel: "purchase_analysis_step1_submit",
        },
    },
    purchase_analysis_step2_submit: {
        description: 'Fires when a user submits Step 2 by clicking the "Next" button.',
        mappings: {
            mixpanel: "purchase_analysis_step2_submit",
        },
    },
    purchase_analysis_step3_submit: {
        description: 'Fires when a user submits Step 3 by clicking the "Next" button.',
        mappings: {
            mixpanel: "purchase_analysis_step3_submit",
        },
    },
    purchase_analysis_step4_submit: {
        description: 'Fires when a user submits Step 4 by clicking the "Next" button.',
        mappings: {
            mixpanel: "purchase_analysis_step4_submit",
        },
    },
    purchase_analysis_step1_success: {
        description: "Fires when a user successfully completes Step 1 and moves forward in the process.",
        mappings: {
            mixpanel: "purchase_analysis_step1_success",
        },
    },
    purchase_analysis_step2_success: {
        description: "Fires when a user successfully completes Step 2 and moves forward in the process.",
        mappings: {
            mixpanel: "purchase_analysis_step2_success",
        },
    },
    purchase_analysis_step3_success: {
        description: "Fires when a user successfully completes Step 3 and moves forward in the process.",
        mappings: {
            mixpanel: "purchase_analysis_step3_success",
        },
    },
    purchase_analysis_step4_success: {
        description: "Fires when a user successfully completes Step 4 and moves forward in the process.",
        mappings: {
            mixpanel: "purchase_analysis_step4_success",
        },
    },
    client_manager_add_client_click: {
        description: 'Fires when the user clicks "Add Client"',
        mappings: {
            mixpanel: "client_manager_add_client_click",
        },
    },
    client_manager_client_click: {
        description: "Fires when the user clicks on a client's name in the list.",
        mappings: {
            mixpanel: "client_manager_client_click",
        },
    },
    account_settings_branding_save_success: {
        description:
            "Fires when the user successfully saves updates in the Personal Branding tab (photo, company info, NMLS, contact details).",
        mappings: {
            mixpanel: "account_settings_branding_save_success",
        },
    },
    account_settings_cobrand_add_success: {
        description: "Fires when the user successfully adds a new Co-Branding partner.",
        mappings: {
            mixpanel: "account_settings_cobrand_add_success",
        },
    },
    account_settings_cobrand_invite_success: {
        description: "Fires when the user successfully sends an invite to a new Co-Branding partner.",
        mappings: {
            mixpanel: "account_settings_cobrand_invite_success",
        },
    },
    account_settings_notifications_toggle_success: {
        description:
            "Fires when the user successfully updates a notification preference (Strike Rate, Lock Alerts, or Market Update).",
        mappings: {
            mixpanel: "account_settings_notifications_toggle_success",
        },
    },
    account_settings_voice_phone_update_initiated: {
        description: "Fires when the user successfully saves an updated voice alert phone number.",
        mappings: {
            mixpanel: "account_settings_voice_phone_update_initiated",
        },
    },
    account_settings_text_phone_update_initiated: {
        description: "Fires when the user successfully saves an updated text alert phone number.",
        mappings: {
            mixpanel: "account_settings_text_phone_update_initiated",
        },
    },
    account_settings_preferences_save_success: {
        description: "Fires when the user successfully saves Appearance or Market Settings updates.",
        mappings: {
            mixpanel: "account_settings_preferences_save_success",
        },
    },
    account_settings_receipt_download_success: {
        description: "Fires when the user successfully downloads a receipt file.",
        mappings: {
            mixpanel: "account_settings_receipt_download_success",
        },
    },
    account_settings_respa_invoice_download_success: {
        description: "Fires when the user successfully downloads a RESPA invoice.",
        mappings: {
            mixpanel: "account_settings_respa_invoice_download_success",
        },
    },
    account_settings_receipt_email_sent: {
        description:
            "Fires when the user successfully sends a receipt email from the Subscriptions & Order History tab.",
        mappings: {
            mixpanel: "account_settings_receipt_email_sent",
        },
    },
    account_settings_receipt_email_opened: {
        description: "Fires when a recipient opens a receipt email.",
        mappings: {
            mixpanel: "account_settings_receipt_email_opened",
        },
    },
    account_settings_receipt_email_clicked: {
        description: "Fires when a user clicks a link within the receipt email.",
        mappings: {
            mixpanel: "account_settings_receipt_email_clicked",
        },
    },
    account_settings_cobrand_invite_email_sent: {
        description: "Fires when a Co-Branding invite email is successfully sent to an agent.",
        mappings: {
            mixpanel: "account_settings_cobrand_invite_email_sent",
        },
    },
    account_settings_cobrand_invite_email_opened: {
        description: "Fires when the invited agent opens the Co-Branding invite email.",
        mappings: {
            mixpanel: "account_settings_cobrand_invite_email_opened",
        },
    },
    account_settings_cobrand_invite_email_clicked: {
        description: "Fires when a recipient clicks a link within the Co-Branding invite email.",
        mappings: {
            mixpanel: "account_settings_cobrand_invite_email_clicked",
        },
    },
    account_settings_password_update_success: {
        description:
            "Fires when the user successfully updates their password (MBS or redirected ListReports flow).",
        mappings: {
            mixpanel: "account_settings_password_update_success",
        },
    },
};
